// testimonial.service.ts
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  limit,
} from 'firebase/firestore';
import { getFirebaseFirestore } from '@bookstore/shared/browser';
import { Testimonial, COLLECTIONS } from '@bookstore/shared';

class TestimonialService {
  private collectionName = COLLECTIONS.TESTIMONIALS;

  private get db() {
    return getFirebaseFirestore();
  }

  async getApprovedTestimonials(limitCount?: number): Promise<Testimonial[]> {
    const ref = collection(this.db, this.collectionName);
    let q = query(ref, where('isApproved', '==', true), orderBy('createdAt', 'desc'));
    if (limitCount) q = query(q, limit(limitCount));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() })) as Testimonial[];
  }


}

export const testimonialService = new TestimonialService();
